var map = {
	"./adjustPolicy/legal.ts": [
		54932,
		932
	],
	"./adjustPolicy/liability.ts": [
		19091,
		91
	],
	"./bike-spain.ts": [
		70507,
		507
	],
	"./claims/dog-liability.ts": [
		10017,
		17
	],
	"./claims/legal.ts": [
		68236,
		236
	],
	"./dental-spain.ts": [
		7607,
		607
	],
	"./dog-liability.ts": [
		79266,
		266
	],
	"./home-france.ts": [
		78746,
		746
	],
	"./home-spain.ts": [
		87894,
		894
	],
	"./life-eu.ts": [
		94359,
		359
	],
	"./public-health-aok.ts": [
		28223,
		223
	],
	"./public-health-barmer.ts": [
		57949,
		949
	],
	"./public-health-bkkfirmus.ts": [
		85019,
		19
	],
	"./public-health-dak.ts": [
		64851,
		851
	],
	"./public-health-tk.ts": [
		22625,
		625
	],
	"./travel-health.ts": [
		2012,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47726;
module.exports = webpackAsyncContext;